import { useQuery } from "@tanstack/react-query";

import type { Page } from "@/api/api.types";
import type { IChatConversationListItem } from "@/api/chat/chat.types";
import { useOwnedPageWithPendingPins } from "@/hooks/usePinConversation";
import { ownedConversationsQueryOptions } from "@/pages/frontend/chat/adapters/api-thread-list-adapter";

/**
 * Reactive view of the owner's conversation list. Shares
 * `ownedConversationsQueryOptions` with the adapter's `list()` seed, so a warm
 * cache is reused with no extra round-trip (a concurrent cold-cache fetch is
 * deduped with `list()`'s). A pin whose PUT is still in flight is laid over
 * the cached page, so a refetch that lands meanwhile cannot move its row back.
 */
export function useOwnedConversations():
    | Page<IChatConversationListItem>
    | undefined {
    const { data } = useQuery(ownedConversationsQueryOptions);
    return useOwnedPageWithPendingPins(data);
}
